import React, { useEffect, useState } from "react";
import PackagePlanManager from "../../../services/dashboard/PackageManager";
import PackagePlanCard from "./PackagePlanCard";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import CityManager from "../../../services/home/CityManager";
import { AlertTriangle, MapPin } from "lucide-react";
import { LocationServiceModal } from "./LocationServiceModal";
import ServiceabilityCheckModal from "./ServiceabilityCheckModal";

const PlansList = ({ subscriptionType = "NEW" }) => {
  const [plans, setPlans] = useState([]);
  const [isUserLocationServiceable, setIsUserLocationServiceable] =
    useState(true);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showServiceabilityCheckModal, setShowServiceabilityCheckModal] = useState(false);
  const user = useSelector((s) => s.auth.user);

  // Fetch and validate city/pincode
  useEffect(() => {
    CityManager.getActiveCitiesWithPincodes()
      .then((cities) => {
        if (!user?.cityId || !user?.pinId) return;

        const city = cities.find((c) => c.cityId === user.cityId && c.active);
        const pin = city?.pincodes?.find(
          (p) => p.pinId === user.pinId && p.active
        );
        const isValid = !!(city && pin);

        setIsUserLocationServiceable(isValid);

        if (!isValid) {
          setShowServiceModal(true); // Show the modal
        }
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Failed to verify location serviceability.", {
          id: "service-check",
        });
        setIsUserLocationServiceable(false);
      });
  }, [user?.cityId, user?.pinId]);

  // Fetch plans
  useEffect(() => {
    PackagePlanManager.getAllBookPackagePlans()
      .then(setPlans)
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-2 text-center text-primary">
        Choose Your Plan
      </h1>

      <div className="text-center text-text-black py-2 px-6">
        <p>
          You can choose a convenient, affordable membership plan as per your
          choice.
        </p>
      </div>

      {/* ❗ Red alert if not serviceable */}
      {!isUserLocationServiceable && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-md flex items-center gap-2 mb-6">
          <AlertTriangle className="w-5 h-5" />
          <span>Service is not available in your area.</span>
        </div>
      )}

      {/* 🌍 Check Serviceability Button */}
      <div className="mb-6 flex justify-center">
        <button
          onClick={() => setShowServiceabilityCheckModal(true)}
          className="flex items-center gap-2 px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-300 shadow-md hover:shadow-lg"
        >
          <MapPin size={20} />
          Check Serviceability
        </button>
      </div>

      {/* 🧾 Plan Cards */}
      {plans.map((plan) => (
        <PackagePlanCard
          key={plan.planId}
          plan={plan}
          subscriptionType={subscriptionType}
          isUserLocationServiceable={isUserLocationServiceable}
        />
      ))}
      {showServiceModal && (
        <LocationServiceModal onClose={() => setShowServiceModal(false)} />
      )}
      
      {/* Serviceability Check Modal */}
      <ServiceabilityCheckModal
        isOpen={showServiceabilityCheckModal}
        onClose={() => setShowServiceabilityCheckModal(false)}
      />
    </div>
  );
};

export default PlansList;
